
export default function ValueProposition() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-16 text-gray-900">
          Why Dinari Designs Delivers Superior Value
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mb-6">
              <i className="ri-medal-fill text-white text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              20+ Years Expertise
            </h3>
            <p className="text-gray-700 leading-relaxed">
              Decades of specialized experience in high-rise construction detailing. We've seen every
              challenge and know how to prevent costly mistakes before they happen.
            </p>
          </div>

          <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-6">
              <i className="ri-shield-check-fill text-white text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              Quality Guaranteed
            </h3>
            <p className="text-gray-700 leading-relaxed">
              Every detailing package undergoes rigorous quality control. We stand behind our work
              with professional liability insurance and a track record of zero field errors.
            </p>
          </div>

          <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mb-6">
              <i className="ri-time-fill text-white text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              24/7 Availability
            </h3>
            <p className="text-gray-700 leading-relaxed">
              Construction doesn't stop, and neither do we. Flexible scheduling and rapid turnaround
              times ensure your project stays on schedule without delays.
            </p>
          </div>

          <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-orange-600 rounded-full flex items-center justify-center mb-6">
              <i className="ri-line-chart-fill text-white text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              Scalable Service
            </h3>
            <p className="text-gray-700 leading-relaxed">
              Scale up during peak construction phases, scale down during planning. Pay only for what
              you need, when you need it, without long-term employment commitments.
            </p>
          </div>

          <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mb-6">
              <i className="ri-team-fill text-white text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              Zero HR Burden
            </h3>
            <p className="text-gray-700 leading-relaxed">
              No recruiting, interviewing, training, or managing. No benefits administration,
              payroll taxes, or termination concerns. Focus on building, not HR.
            </p>
          </div>

          <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mb-6">
              <i className="ri-shield-star-fill text-white text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              Risk Mitigation
            </h3>
            <p className="text-gray-700 leading-relaxed">
              Eliminate the risk of relying on a single junior employee. Our proven systems and
              experienced team ensure consistent, accurate results on every project.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
